export const enum SizeMax {
    Xs = 575,
    Sm = 767,
    Md = 991,
    Lg = 1199,
    Xl = 1399
}